package com.ustadmobile.lib.db.entities

import kotlinx.serialization.Serializable

@Serializable
class UidAndLabel {

    var uid: Long = 0

    var labelName: String? = null

}